<script lang="ts">
import { defineComponent } from 'vue'
import { useNotificationStore } from '../libs/notificationStore'

export default defineComponent({
  setup () {
    const notificationStore = useNotificationStore()
    return {
      notificationStore
    }
  }
})
</script>

<template>
  <ul class="NotificationList">
    <transition-group>
      <li class="NotificationList-item" :class="v.type && `NotificationList-item--${v.type}`" v-for="v in notificationStore.list" :key="v.id">{{ v.message }}</li>
    </transition-group>
  </ul>
</template>

<style lang="scss" scoped>
.NotificationList {
  position: fixed;
  top: 5px;
  left: 5px;
  right: 5px;
  display: flex;
  flex-direction: column;
  pointer-events: none;
  z-index: 20000;
  &-item {
    margin: 5px auto;
    padding: 7px 12px;
    background-color: rgba(0, 0, 0, 0.6);
    color: white;
    border-radius: 10px;
    backdrop-filter: blur(3px);
    &--success {
      background-color: color-mix(in srgb, color-mix(in srgb, var(--green) 70%, black) 70%, transparent);
    }
    &--warn {
      background-color: rgba(220, 180, 16, 0.7);
      color: #222;
    }
    &--error {
      background-color: rgba(200, 0, 0, 0.7);
    }
  }
}
.v-enter-active,
.v-leave-active {
  transition: 0.2s;
}
.v-enter-active {
  transition-timing-function: cubic-bezier(.02,.73,.49,1.24);
}
.v-leave-active {
  transition-timing-function: ease-in;
}
.v-enter-from,
.v-leave-to {
  transform: scale(0);
}
.v-leave-to {
  margin-top: -30px;
  opacity: 0;
}
.v-enter-to,
.v-leave-from {
  transform: scale(1);
}
</style>
